import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { slugify, formatPostDate } from "../../utils/slug";
import "./LatestNews.css";

const LatestNews = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    fetch("https://ekselowe.pl/api/getposts.php", {
      headers: { "Content-Type": "application/json; charset=UTF-8" },
    })
      .then((response) => response.json())
      .then((json) => {
        const keys = Object.keys(json || {}).reverse().slice(0, 3);
        setPosts(keys.map((key) => ({ id: key, ...json[key] })));
      })
      .catch(() => setPosts([]));
  }, []);

  if (posts === null || posts.length === 0) {
    return null;
  }

  return (
    <div className="latest-news-panel" id="latest-news-id">
      <div className="latest-news-container">
        <div className="latest-news-heading-row">
          <div>
            <p className="title">co u nas nowego</p>
            <p className="subtitle-dark">Aktualności</p>
          </div>
          <button
            type="button"
            className="latest-news-all-button"
            onClick={() => navigate("/aktualnosci")}
          >
            Zobacz wszystkie →
          </button>
        </div>
        <div className="latest-news-grid">
          {posts.map((post) => (
            <div
              className="latest-news-card"
              key={post.id}
              onClick={() => navigate(`/aktualnosci/${slugify(post.title)}`)}
            >
              {post.image && (
                <img src={post.image} alt={post.title} className="latest-news-image" />
              )}
              <div className="latest-news-card-body">
                <h3 className="latest-news-card-title">{post.title}</h3>
                {post.date && <p className="latest-news-card-date">{formatPostDate(post.date)}</p>}
                {post.text && <p className="latest-news-card-text">{post.text}</p>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
